'use client';
import { Link } from '@/shared/ui/link';
import { BodyTextMediumC } from '@/shared/ui/typography2';
import styled from 'styled-components';
import { useCurrentLocale, useI18n } from '@locales/client';
import {
  getBettingMenu,
  getInfoMenu,
} from '@/entities/minibanner/model/bannerHelper';

export type MenuType = 'info' | 'game' | 'betting';

export const NavigationMenu = ({ menu = 'info' }: { menu?: MenuType }) => {
  const loc = useI18n();
  const locale = useCurrentLocale();

  const buttons = menu !== 'betting' ? getInfoMenu() : getBettingMenu();
  // const buttons: Array<{ page: string; text: string }> = [
  //   { page: '', text: 'common.footer.home' },
  //   { page: 'games', text: 'common.footer.games' },
  //   { page: 'betting', text: 'common.footer.betting' },
  //   { page: 'bonuses', text: 'common.footer.bonus' },
  //   { page: 'status', text: 'minibanners.status' },
  //   { page: 'games/favorite', text: 'mini_games_banners.wishlist' },
  // ];

  const getButtonLink = (page: string) => {
    return `/${locale}/${page}`;
  };
  return (
    <PortalMenuContainer $isShort={menu === 'betting'}>
      <PortalMenu $columnsCount={buttons.length}>
        {buttons.map((button) => (
          <PortalButton
            key={button.param}
            href={getButtonLink(button.fullParam ?? button.param)}
          >
            <BodyTextMediumC>{loc(button.tKey)}</BodyTextMediumC>
          </PortalButton>
        ))}
      </PortalMenu>
    </PortalMenuContainer>
  );
};

const PortalMenuContainer = styled.div<{ $isShort: boolean }>`
  width: 100%;
  height: 44px;
  overflow-x: auto;

  ${({ $isShort }) =>
    $isShort &&
    `
        display: flex;
        justify-content: center;
      `}
`;

const PortalMenu = styled.nav<{ $columnsCount: number }>`
  display: grid;
  height: 44px;
  grid-template-columns: repeat(${({ $columnsCount }) => $columnsCount}, auto);
  gap: 12px;
`;
const PortalButton = styled(Link)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 9px;
  flex: 1 0 0;
  align-self: stretch;
  cursor: pointer;

  border-radius: 8px;
  background: #27262b;
  min-width: 100px;

  @media (max-width: 768px) {
    width: 100px;
  }
`;
